"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_DATEV_ACCOUNT_NUMBER_LENGTH = exports.MIN_DATEV_ACCOUNT_NUMBER_LENGTH = exports.MAX_DATEV_CONSULTANT_NUMBER = exports.MIN_DATEV_CONSULTANT_NUMBER = exports.MAX_DATEV_CLIENT_NUMBER = exports.MIN_DATEV_CLIENT_NUMBER = exports.ALLOWED_DATEV_BU_CODES = void 0;
exports.ALLOWED_DATEV_BU_CODES = [
    1,
    6,
    7,
    8,
    9,
    16,
    17,
    18,
    19,
    40,
    49,
    ...[...Array(10).keys()].map((i) => i + 50),
    91,
    92,
    94,
    95,
    97,
    98,
    99,
    400,
    401,
    402,
    490,
    506,
    507,
    511,
    512,
    516,
    517,
    521,
    522,
    525,
    526,
    527,
    531,
    532,
    536,
    537,
    541,
    542,
    546,
    547,
    551,
    552,
    556,
    557,
    561,
    562,
    566,
    567,
    701,
    702,
    ...[...Array(100).keys()].map((i) => i + 900),
    6501,
    6502,
    6506,
    6507,
    6511,
    6512,
    6516,
    6517,
    6521,
    6522,
    6526,
    6527,
    6531,
    6532,
    6536,
    6537,
    6541,
    6542,
    6546,
    6547,
    6551,
    6552,
    6556,
    6557,
    6561,
    6562,
    6566,
    6567,
    6701,
    6702,
    9401,
    9402,
    9501,
    9506,
    9701,
    9510,
];
exports.MIN_DATEV_CLIENT_NUMBER = 1;
exports.MAX_DATEV_CLIENT_NUMBER = 99999;
exports.MIN_DATEV_CONSULTANT_NUMBER = 1001;
exports.MAX_DATEV_CONSULTANT_NUMBER = 9999999;
exports.MIN_DATEV_ACCOUNT_NUMBER_LENGTH = 4;
exports.MAX_DATEV_ACCOUNT_NUMBER_LENGTH = 8;
